import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFormSectionComponent } from '../../molecules/form-section/form-section.component';
import type {
  UiDocumentTotalsCurrencyMode,
  UiDocumentTotalsItem,
} from './document-totals.types';

export type {
  UiDocumentTotalsCurrencyMode,
  UiDocumentTotalsItem,
} from './document-totals.types';

/**
 * Organismo: barra de totales de un documento, de ancho completo y
 * anclada al borde inferior de su contenedor de desplazamiento.
 *
 * Presentacional. La página formatea los importes y, en modo campo,
 * proyecta Divisa y Tipo de cambio. En modo etiqueta esos datos se
 * muestran como texto. Las columnas extra cubren variantes como
 * Gasto por comprobar.
 */
@Component({
  selector: 'ui-document-totals',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiFormSectionComponent],
  templateUrl: './document-totals.component.html',
  styleUrl: './document-totals.component.scss',
  host: {
    class: 'ui-document-totals-host',
  },
})
export class UiDocumentTotalsComponent {
  /** `field` proyecta los controles; `label` pinta Divisa como texto. */
  readonly currencyMode = input<UiDocumentTotalsCurrencyMode>('field');

  /** Texto de Divisa. Solo se muestra en modo etiqueta. */
  readonly currency = input('');

  /**
   * Texto de Tipo de cambio. Solo se muestra en modo etiqueta.
   * `null` oculta la columna.
   */
  readonly exchangeRate = input<string | null>(null);

  /** Columnas adicionales entre la divisa y los importes fijos. */
  readonly extraItems = input<readonly UiDocumentTotalsItem[]>([]);

  readonly subtotal = input.required<string>();
  readonly iva = input.required<string>();
  readonly retencionIsr = input.required<string>();
  readonly retencionIva = input.required<string>();
  readonly importe = input.required<string>();
}
